import React from 'react';

const StyledItem = React.forwardRef((props, ref) => {
  const {
    itemClass,
    active = false,
    itemPre = null, // status indicator, etc
    headerLabel, // visible label
    headerContent, // visible content
    headerActions, // visible action buttons
    bodyActions, // collapsibe content actions
    bodyActionsPosition = 'right',
    children, // collapsible content
    onClick = () => null,
    isPublic,
  } = props;

  const darkmode = localStorage.getItem('nightmode') === 'true';

  return (
    <div
      data-testid="styled-item"
      ref={ref}
      className={`styled-item ${itemClass || ''} ${active ? 'open' : 'closed'}`}
    >
      {itemPre}
      <div
        className={`styled-item__content ${isPublic ? 'isPublic' : 'isPrivate'}`}
        style={isPublic === false && !darkmode ? { backgroundColor: '#F0F0F0' } : {}}
      >
        <div
          data-testid="header"
          className="styled-item__header"
          onClick={onClick}
        >
          {headerLabel ? (
            <div
              data-testid="header-label"
              className="styled-item__header__label"
            >
              {headerLabel}
            </div>
          ) : null}
          <div
            data-testid="header-content"
            className="styled-item__header__info"
          >
            {headerContent}
          </div>
          <div
            data-testid="header-actions"
            className="styled-item__header__actions"
          >
            {headerActions}
          </div>
        </div>

        <div
          data-testid="body"
          className="styled-item__body"
        >
          {children}
          {bodyActions ? (
            <div
              data-testid="body-actions"
              className={`button-row ${bodyActionsPosition}`}
            >
              {bodyActions}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
});

export default StyledItem;
